import { BaseXYAxisChartOptions, LegendOptions } from '@sprinklr/stories/hyperspaceWidgets/types';
import { observable } from 'mobx';
import { WidgetOptionsImpl } from 'models/Widget/WidgetOptions';

import { HyperSpaceLineChartWidgetOptions } from './types';

export class HyperSpaceLineChartWidgetOptionsImpl extends WidgetOptionsImpl
    implements HyperSpaceLineChartWidgetOptions {
    @observable baseXYChartOptions: BaseXYAxisChartOptions = {
        grid: {
            enabled: false,
        },
        xAxis: {
            ticks: {
                formats: {
                    numberFormat: {
                        decimals: 0,
                        useShortened: true,
                    },
                    dateFormat: {
                        autoFormat: true,
                        formatString: 'dd MMM',
                    },
                },
                numTicks: 5,
            },
            enabled: true,
            label: {
                enabled: true,
                size: 50,
            },
            line: {
                enabled: false,
                stroke: '',
                strokeWidth: 1,
            },
        },
        yAxis: {
            ticks: {
                formats: {
                    numberFormat: {
                        decimals: 0,
                        useShortened: true,
                    },
                    dateFormat: {
                        autoFormat: true,
                        formatString: 'dd MMM',
                    },
                },
                //TODO: how should we actually set initial value
                numTicks: 5,
            },
            enabled: true,
            label: {
                enabled: true,
                size: 50,
            },
            line: {
                enabled: false,
                stroke: '',
                strokeWidth: 1,
            },
        },
    };
    @observable zeroFill = true;
    @observable legend: LegendOptions = {
        enabled: true,
        position: {
            auto: true,
            selectedPosition: 'top',
        },
    };
}
